import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const { user }     = useAuth();
  const socketRef    = useRef(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('accessToken');
    const socket = io(process.env.REACT_APP_SOCKET_URL || window.location.origin, {
      auth: { token },
      transports: ['websocket'],
    });

    socket.on('connect',    () => { setConnected(true);  console.log('🔌 Socket connected'); });
    socket.on('disconnect', () => { setConnected(false); console.log('🔌 Socket disconnected'); });

    socketRef.current = socket;
    return () => { socket.disconnect(); socketRef.current = null; };
  }, [user]);

  const emit = (event, data) => socketRef.current?.emit(event, data);
  const on   = (event, cb)  => { socketRef.current?.on(event, cb); return () => socketRef.current?.off(event, cb); };
  const off  = (event, cb)  => socketRef.current?.off(event, cb);

  return (
    <SocketContext.Provider value={{ socket: socketRef.current, connected, emit, on, off }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
